import { Rule } from "antd/lib/form";

const RULES = {
  required: { required: true } as Rule,
};

export default RULES;
